import api from "./../Api";
import { BaseService } from "./../BaseService";

const URL = 'articles/comments';

export class ArticlesCommentsService extends BaseService {
    async list(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async listUpdates(): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`${URL}/updates`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async fetch(articleId: number, comment: string, id: number | null): Promise<any> {
        try {
            return id ? this.handleResponse(await api.put(`${URL}/update`, { article_id: articleId, comment, id })) :
                this.handleResponse(await api.post(`${URL}/create`, { article_id: articleId, comment }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async delete(id: number): Promise<any> {
        try {
            return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}